<template lang="pug">
  toggle-button.text-center.align-middle.m-0(:value="!isInvalid", @change="toggleInvalid()", :labels="true", :sync="true")
  </template>
  
  <script>
  import TagDomainApi from '../../apis/tag_domain';
  
  export default {
    props: {
      tag_domain_id: Number,
      is_invalid: Boolean,
    },
    data(){
      return {
        isInvalid: this.is_invalid,
        tagDomainId: this.tag_domain_id,
      }; 
    },
    methods: {
      async toggleInvalid() {
        const originValue = this.isInvalid
  
        this.isInvalid = !this.isInvalid;
        try {
          const response = await TagDomainApi.toggle_invalid({
            tag_domain_id: this.tagDomainId,
            is_invalid: this.isInvalid,
          });
  
          if (response.data.status === 'success') {
            if (response.data && response.data.message) {
              this.$toasted.success(response.data.message);
            } else {
              this.$toasted.success('操作を実行しました');
            }
            await sleep(10000);
            this.$toasted.clear();
          } else if (response.data.status === 'error') {
            this.isInvalid = originValue;
            if (response.data && response.data.error && response.data.error_method === 'valid_is_verified') {
              this.$toasted.error(response.data.error);
            } else if (response.data && response.data.error) {
              const domain_limit = response.data.domain_limit;
              const dummyEvent = {
                preventDefault: () => {},
              };
              const modalData = {
                title: 'プランのアップグレードが必要です。',
                content: {
                  title: `現在のプランでは、ご利用できるWebサイトは${domain_limit}個までです。`,
                  message: 'プランをアップグレードすることで、ご利用できるWebサイトの数を増やすことができ、上位プラン専用の高機能もご利用いただけます。',
                  link: {
                    url: '/users/plans',
                    text: 'プランをアップグレード',
                  },
                },
                class: 'callout-info',
              };
              window.users_vue_app.openGeneralModal(dummyEvent, modalData);
            } else {
              this.$toasted.error('エラーが発生しました'); // error が存在しない場合の代替メッセージ
            }
            await sleep(10000);
            this.$toasted.clear();
          } else {
            this.isInvalid = originValue;
            this.$toasted.error('予期せぬエラーが発生しました');
            await sleep(10000);
            this.$toasted.clear();
          }
        } catch (error) {
          this.isInvalid = originValue;
          this.$toasted.error('エラーが発生しました'); // 通信エラーなどの場合
          await sleep(10000);
          this.$toasted.clear();
        }
      },
    }
  }
  </script>